export const InfoJson = {
    title: {
        text: 'Check taxes off your to-do list',
        styles: {
            color: '#FFF',
            textAlign: 'center'
        }
    },
    header: {
        text: 'Get started on your taxes now!',
        turboIconUrl:
            'https://dam.freedommortgage.com/dx/api/dam/v1/collections/cf1d185b-4640-4b07-83ce-44b1b9f2ad90/items/89bebe1b-9f41-4958-a7a4-00ef5a42cf8b/renditions/1b2efc15-daae-40cf-be67-0860b8871e42?binary=true',
        styles: {
            color: '#222A34',
            lineHeight: 'normal',
            textAlign: 'center'
        }
    },
    body: {
        content: [
            {
                icon: 'check-circle-outline',
                text: 'Expert help or do your own taxes',
                styles: {
                    color: '#222A34'
                }
            },
            {
                icon: 'check-circle-outline',
                text: 'Accurate calculations, guaranteed*',
                styles: {
                    color: '#222A34'
                }
            },
            {
                icon: 'check-circle-outline',
                text: 'Maximum refund, guaranteed*',
                styles: {
                    color: '#222A34'
                }
            }
        ],
        button: {
            text: 'START YOUR TAXES',
            url: 'http://turbotax.intuit.com/affiliate/freedo7?cid=all_freedo7-acp1098_aff',
            styles: {
                color: '#FFF',
                fontSize: '18px',
                fontWeight: '500',
                lineHeight: '21px'
            }
        },
        disclaimer: {
            text: '*Visit <a href="http://turbotax.intuit.com/lp/yoy/guarantees.jsp" target="_blank"  style="color:#222A34;">http://turbotax.intuit.com/lp/yoy/guarantees.jsp</a> for TurboTax product guarantees and other important information.',
            styles: {
                color: '#222A34',
                textAlign: 'center'
            }
        }
    },

    globalStyles: {
        titleStyles: {
            backgroundColor: '#0A4A8D'
        },
        bodyStyles: { backgroundColor: '#FFF' }
    }
};
